(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waelo-vault"]) return;
  try {
    
(function(){
"use strict";
const validation=document.getElementById("waeloVaultValidation");
if(!validation)return;
const canvas=document.getElementById("waeloVaultMatrix");
const ctx=canvas.getContext("2d");
const status=document.getElementById("waeloVaultStatus");
const progress=document.getElementById("waeloVaultProgress");
const final=document.getElementById("waeloVaultFinal");
const finalTitle=document.getElementById("waeloVaultFinalTitle");
const finalSub=document.getElementById("waeloVaultFinalSub");
const access=validation.dataset.access==="granted";
const steps=Array.from(
document.querySelectorAll(".waelo-vault-validation-step")
);
let width=0;
let height=0;
let columns=[];
const chars="01ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789<>[]{}$#@+*";
function resizeMatrix(){
const ratio=Math.min(
window.devicePixelRatio||1,
2
);
width=window.innerWidth;
height=window.innerHeight;
canvas.width=width*ratio;
canvas.height=height*ratio;
canvas.style.width=width+"px";
canvas.style.height=height+"px";
ctx.setTransform(
ratio,
0,
0,
ratio,
0,
0
);
const fs=window.innerWidth<600?11:13;
const count=Math.ceil(width/fs);
columns=Array.from(
{length:count},
()=>({
x:Math.random()*width,
y:Math.random()*height,
speed:.7+Math.random()*1.5,
length:5+Math.floor(Math.random()*13)
})
);
}
function drawMatrix(){
ctx.fillStyle="rgba(8,11,14,.12)";
ctx.fillRect(
0,
0,
width,
height
);
ctx.font=
(window.innerWidth<600?11:13)
+"px monospace";
columns.forEach(c=>{
for(let i=0;i<c.length;i++){
const a=1-i/c.length;
ctx.fillStyle=
Math.random()>.93
?
"rgba(255,86,14,"+(a*.55)+")"
:
"rgba(0,200,255,"+(a*.38)+")";
ctx.fillText(
chars[
Math.floor(
Math.random()*chars.length
)
],
c.x,
c.y-i*15
);
}
c.y+=c.speed*5;
if(c.y-c.length*15>height){
c.y=-Math.random()*height;
}
});
requestAnimationFrame(drawMatrix);
}
resizeMatrix();
drawMatrix();
window.addEventListener(
"resize",
resizeMatrix
);
const messages=[
"Connecting to secure WÄELO member system...",
"Customer session detected and verified.",
"Reading current membership credentials...",
"Checking WÄELO Vault authorization...",
access
?
"WAELO_VAULT credential found."
:
"WAELO_VAULT credential not found."
];
const wait=ms=>
new Promise(
resolve=>setTimeout(resolve,ms)
);
async function runValidation(){
await wait(350);
for(let i=0;i<steps.length;i++){
const step=steps[i];
const icon=
step.querySelector(
".waelo-vault-validation-icon"
);
const result=
step.querySelector(
".waelo-vault-validation-result"
);
step.classList.add("active");
icon.textContent="···";
result.textContent="CHECKING";
status.textContent=messages[i];
progress.style.width=
i/steps.length*100+"%";
await wait(470);
step.classList.remove("active");
if(
i===steps.length-1 &&
!access
){
step.classList.add("failed");
icon.textContent="×";
result.textContent="NOT FOUND";
}else{
step.classList.add("done");
icon.textContent="✓";
result.textContent="VERIFIED";
}
progress.style.width=
(i+1)/steps.length*100+"%";
await wait(120);
}
if(access){
finalTitle.textContent=
"ACCESS VERIFIED";
finalSub.textContent=
"WÄELO Vault credentials accepted.";
final.classList.add("show");
status.textContent=
"Secure member access confirmed.";
}else{
final.classList.add("failed");
finalTitle.textContent=
"ACCESS NOT ACTIVE";
finalSub.textContent=
"Vault credentials were not found on this account.";
final.classList.add("show");
status.textContent=
"Membership verification complete.";
}
await wait(
access
?
1050
:
900
);
validation.classList.add(
"is-complete"
);
await wait(800);
if(validation.parentNode){
validation.parentNode.removeChild(
validation
);
}
}
runValidation();
})();

  } catch(e) { console.error(e); }
})();
})();
